export enum CreditStatusEnum {
  credit = 'C',
  noCredit = 'N'
};
